import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { getClaimStatusLineChartData } from "../api/ClaimAPI";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnTypeClaimStatusLineChartData = typeof getClaimStatusLineChartData;

export const useClaimStatusLineChartData = (config?: QueryConfig<QueryFnTypeClaimStatusLineChartData>) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const filterByUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser ?? false);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        filterByCurrentUser: filterByUser,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeClaimStatusLineChartData>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["ClaimStatusLineChartData", filterByUser, filters, currentUser],
        queryFn: () => getClaimStatusLineChartData(paginationFilters), 
    });
}